var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 17,
    viewBox: "0 0 22 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8877 7.55835C18.2827 7.36235 19.3567 6.16635 19.3597 4.71735C19.3597 3.28935 18.3187 2.10535 16.9537 1.88135",
    stroke: "#9CA3AF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7285 10.9121C20.0795 11.1141 21.0225 11.5871 21.0225 12.5621C21.0225 13.2331 20.5785 13.6691 19.8605 13.9431",
    stroke: "#9CA3AF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8867 11.3254C7.67273 11.3254 4.92773 11.8124 4.92773 13.7574C4.92773 15.7014 7.65573 16.2024 10.8867 16.2024C14.1007 16.2024 16.8447 15.7204 16.8447 13.7744C16.8447 11.8284 14.1177 11.3254 10.8867 11.3254Z",
    stroke: "#9CA3AF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8869 8.54962C12.9959 8.54962 14.7059 6.84062 14.7059 4.73062C14.7059 2.62162 12.9959 0.911621 10.8869 0.911621C8.7779 0.911621 7.0679 2.62162 7.0679 4.73062C7.0599 6.83262 8.7569 8.54262 10.8589 8.54962H10.8869Z",
    stroke: "#9CA3AF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.88484 7.55835C3.48884 7.36235 2.41584 6.16635 2.41284 4.71735C2.41284 3.28935 3.45384 2.10535 4.81884 1.88135",
    stroke: "#9CA3AF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.044 10.9121C1.693 11.1141 0.75 11.5871 0.75 12.5621C0.75 13.2331 1.194 13.6691 1.912 13.9431",
    stroke: "#9CA3AF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.5528592938f7e3a2ef72341c51bff116.svg";
export { ForwardRef as ReactComponent };